import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    List,
    ListItemButton,
    ListItemText,

    Breadcrumbs,
    Link as MLink,
    Container,
} from "@mui/material";

import { Link } from "react-router-dom";
import '../../App.css'

import { endpoints } from "../../Api/EndPoints/endpoints";
import { axiosInstance } from "../../Api/Axios/axios";




const leftMenu = [
    "GROUP PROFILE",
    "COMPANY PROFILE",
    "VISION & MISSION",
    "MANAGEMENT TEAM",
    "ROC COMPLIANCE ANNUAL RETURN",
    "CERTIFICATES",
    "AWARDS AND RECOGNITIONS",
    "RESEARCH AND DEVELOPMENT",
    "QUALITY POLICY",
    "CLIENTELE",



];



const CompanyProfile = () => {

    const [data, setData] = useState([]);
    const [rocPdf, setRocPdf] = useState("");

    const fetchData = async () => {
        try {
            const res = await axiosInstance.get(endpoints.AboutUs.companyProfile)
            setData(res?.data?.data)

            const anualpdfRes = await axiosInstance.get(endpoints.AboutUs.anualRetuns)

            // ROC Annual Return PDF
            const rocPdfUrl = anualpdfRes?.data?.data?.[0]?.roc_pdf || "";
            setRocPdf(rocPdfUrl);
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchData()
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    return (
        <Box sx={{ padding: { xs: 2, md: 4 }, mt: "100px" }}>
            <Container maxWidth='xl'>
                {/* Breadcrumb */}
                <Breadcrumbs sx={{ mb: 2, fontSize: "15px" }}>
                    <MLink component={Link} to="/home" underline="hover" color="inherit">
                        Home
                    </MLink>
                    <Typography color="inherit" sx={{ fontSize: "15px" }}>About Us</Typography>

                    <Typography color="text.primary" sx={{ fontSize: "15px" }}>Company Profile</Typography>
                </Breadcrumbs>



                <Grid container spacing={3}>
                    {/* Left Sidebar */}
                    <Grid item size={{ xs: 12, md: 3 }} sx={{ mt: 2 }}>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "15px",
                                mb: 2,
                                textTransform: "uppercase",
                                fontFamily: "Roboto"
                            }}
                        >
                            Product & Services
                        </Typography>



                        <List sx={{ border: "1px solid #ddd" }}>
                            {leftMenu.map((item) => {
                                const isActive = item === "COMPANY PROFILE";

                                // Special case for PDF link
                                if (item === "ROC COMPLIANCE ANNUAL RETURN") {
                                    return (
                                        <ListItemButton
                                            key={item}
                                            component="a"
                                            href={rocPdf || "#"}
                                            target={rocPdf ? "_blank" : undefined}
                                            rel={rocPdf ? "noopener noreferrer" : undefined}
                                            disabled={!rocPdf}
                                            sx={{
                                                borderBottom: "1px solid #eee",
                                                backgroundColor: "transparent",
                                                color: "#000",
                                                "&:hover": {
                                                    backgroundColor: "#f5f5f5"
                                                },
                                                fontFamily: "Roboto",
                                                opacity: rocPdf ? 1 : 0.6,
                                                cursor: rocPdf ? "pointer" : "not-allowed"
                                            }}
                                        >
                                            <ListItemText
                                                primary={item}
                                                primaryTypographyProps={{
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    fontFamily: "Roboto"
                                                }}
                                            />
                                        </ListItemButton>
                                    );
                                }

                                // Default items
                                return (
                                    <ListItemButton
                                        key={item}
                                        component={Link}
                                        to={`/about/${item.toLowerCase().replace(/ /g, "-")}`}
                                        sx={{
                                            borderBottom: "1px solid #eee",
                                            background: isActive
                                                ? "linear-gradient(125deg, #14b91d, #1171b0)"
                                                : "transparent",
                                            color: isActive ? "#fff" : "#000",

                                            "&:hover": {
                                                background: isActive
                                                    ? "linear-gradient(125deg, #14b91d, #1171b0)"
                                                    : "#f5f5f5",
                                            },

                                            fontFamily: "Roboto",
                                        }}
                                    >
                                        <ListItemText
                                            primary={item}
                                            primaryTypographyProps={{
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                fontFamily: "Roboto"
                                            }}
                                        />
                                    </ListItemButton>
                                );
                            })}
                        </List>

                    </Grid>

                    {/* Right Content Section */}
                    <Grid item size={{ xs: 12, md: 9 }} sx={{ mt: 3 }}>



                        {/* Introduction */}


                        <Box>


                            {/* profile picture box */}


                            <Box
                                sx={{
                                    mt: 4,
                                    boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
                                    borderRadius: "12px",
                                    p: { xs: 2, md: 3 },
                                    background: "#fff"
                                }}
                            >

                                {/* ================= DESKTOP ONLY ================= */}
                                <Box sx={{ display: { xs: "none", md: "block" } }}>
                                    <Grid container spacing={3} alignItems="stretch">

                                        {/* TEXT LEFT */}
                                        <Grid item size={{ md: 8 }}>
                                            <Typography
                                                dangerouslySetInnerHTML={{ __html: data?.section1_desc }}
                                            />
                                        </Grid>

                                        {/* IMAGE RIGHT */}
                                        <Grid item size={{ md: 4 }}>
                                            <Box
                                                component="img"
                                                src={data?.section1_img}
                                                sx={{
                                                    width: "100%",
                                                    height: "auto",
                                                    maxHeight: "400px",
                                                    objectFit: "cover",
                                                    borderRadius: "10px"
                                                }}
                                            />
                                        </Grid>

                                    </Grid>
                                </Box>

                                {/* ================= TAB + MOBILE ONLY ================= */}
                                <Box sx={{ display: { xs: "block", md: "none" } }}>

                                    <img
                                        src={data?.section1_img}
                                        alt=""
                                        style={{ width: "50%", borderRadius: "8px", justifyContent: "center", display: "block", margin: "0 auto" }}
                                    />

                                    <Box
                                        sx={{ mt: 2 }}
                                        dangerouslySetInnerHTML={{ __html: data?.section1_desc }}
                                    />

                                </Box>

                            </Box>




                            <Box
                                sx={{
                                    mt: 4,
                                    boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
                                    borderRadius: "12px",
                                    p: { xs: 2, md: 3 },
                                    background: "#fff"
                                }}
                            >

                                {/* ================= DESKTOP ONLY ================= */}
                                <Box sx={{ display: { xs: "none", md: "block" } }}>
                                    <Grid container spacing={3} alignItems="stretch">

                                        {/* IMAGE LEFT */}
                                        <Grid item size={{ md: 4 }}>
                                            <Box
                                                component="img"
                                                src={data?.section2_img}
                                                sx={{
                                                    width: "100%",
                                                    height: "auto",
                                                    maxHeight: "400px",
                                                    objectFit: "cover",
                                                    borderRadius: "10px"
                                                }}
                                            />
                                        </Grid>

                                        {/* TEXT RIGHT */}
                                        <Grid item size={{ md: 8 }}>
                                            <Typography
                                                dangerouslySetInnerHTML={{ __html: data?.section2_desc }}
                                            />
                                        </Grid>

                                    </Grid>
                                </Box>

                                {/* ================= TAB + MOBILE ONLY ================= */}
                                <Box sx={{ display: { xs: "block", md: "none" } }}>

                                    <img
                                        src={data?.section2_img}
                                        alt=""
                                        style={{ width: "50%", borderRadius: "8px", justifyContent: "center", display: "block", margin: "0 auto" }}
                                    />

                                    <Box
                                        sx={{ mt: 2 }}
                                        dangerouslySetInnerHTML={{ __html: data?.section2_desc }}
                                    />

                                </Box>

                            </Box>

                            {/* text */}

                            {/* <Box sx={{ mt: 4 }}>

                                <Typography sx={{ fontSize: "18px", fontWeight: "400", fontFamily: "Roboto", lineHeight: "120%" }}
                                    dangerouslySetInnerHTML={{ __html: data?.section3_desc }}

                                >

                                </Typography>

                            </Box> */}

                            {/* image  */}

                            {/* <Grid container spacing={2} mt={6}>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                    <Link to=''>
                                        <img src={data?.image1} alt='' style={{ width: "100%" }} />
                                    </Link>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                    <Link to=''>
                                        <img src={data?.image2} alt='' style={{ width: "100%" }} />
                                    </Link>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 4 }}>
                                    <Link to=''>
                                        <img src={data?.image3} alt='' style={{ width: "100%" }} />
                                    </Link>
                                </Grid>
                            </Grid> */}


                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};



export default CompanyProfile;
